export default __webpack_public_path__ + "static/media/dianoiva_2.300f4108.jpg";